import { Component } from '@angular/core';

import type { IMenuItemAngularComp } from 'ag-grid-angular';
import type { IMenuConfigParams, IMenuItemParams } from 'ag-grid-community';

export interface CustomMenuItemParams extends IMenuItemParams {
  itemClicked?: () => void;
}

@Component({
  standalone: true,
  template: `
    <div>
      <span class="ag-menu-option-part ag-menu-option-icon" role="presentation"></span>
      <span class="ag-menu-option-part ag-menu-option-text" (click)="onClick()">{{ name }}</span>
      <span class="ag-menu-option-part ag-menu-option-shortcut"> </span>
    </div>
  `,
})
export class AGGridMenuItem implements IMenuItemAngularComp {
  name!: string;
  itemClicked: () => void = () => {};

  agInit(params: CustomMenuItemParams): void {
    this.name = params.name;
    this.itemClicked = params.itemClicked || (() => {});
  }

  configureDefaults(): boolean | IMenuConfigParams {
    return true;
  }

  onClick(): void {
    this.itemClicked();
  }
}
